import { render, staticRenderFns } from "./AdminListIframe.vue?vue&type=template&id=df92c75a&"
import script from "./AdminListIframe.vue?vue&type=script&lang=ts&"
export * from "./AdminListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports